import * as React from "react";
import { useEffect, useState } from "react";
import { NoSearchResult } from "components/common";
import PaginatedList, { INITIAL_PAGE } from "components/common/PaginatedList";
import SearchForm from "components/common/SearchForm";
import Spinner from "components/common/Spinner";
import PaginatedItem from "./PaginatedItem";
const pageSizes = [5, 10, 30];
export const DEFAULT_PAGINATION = { page: INITIAL_PAGE, perPage: pageSizes[0], query: "" };
const PaginatedItemOverview = ({
  disableSearchFilter = false,
  onLoad,
  overrideList = void 0,
  onDeleteItem = void 0,
  queryHelper = void 0,
  noDataText = "No items found to display.",
  resultsWrapperComponent: ResultsWrapperComponent = ({ children }) => /* @__PURE__ */ React.createElement("div", null, children),
  overrideItemComponent: OverrideItemComponent = void 0
}) => {
  var _a, _b;
  const [paginatedList, setPaginatedList] = useState();
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  useEffect(() => overrideList && setPaginatedList(overrideList), [overrideList]);
  useEffect(() => {
    let isSubscribed = true;
    onLoad(pagination, isSubscribed).then((response) => {
      if (isSubscribed) {
        setPaginatedList(response);
      }
    });
    return () => {
      isSubscribed = false;
    };
  }, [pagination, onLoad]);
  if (!paginatedList) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const emptyResult = /* @__PURE__ */ React.createElement(NoSearchResult, null, noDataText);
  let itemList;
  if (paginatedList.list && paginatedList.list.size >= 1) {
    itemList = paginatedList.list.toArray().map((item) => {
      if (OverrideItemComponent) {
        return /* @__PURE__ */ React.createElement(OverrideItemComponent, { key: item.id, onDeleteItem, item });
      }
      return /* @__PURE__ */ React.createElement(PaginatedItem, { key: item.id, onDeleteItem, item });
    });
  }
  return /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      onChange: (newPage, newPerPage) => setPagination({ ...pagination, page: newPage, perPage: newPerPage }),
      pageSize: pagination.perPage,
      totalItems: (_b = (_a = paginatedList == null ? void 0 : paginatedList.pagination) == null ? void 0 : _a.total) != null ? _b : 0,
      pageSizes,
      activePage: pagination.page,
      useQueryParameter: false
    },
    !disableSearchFilter && /* @__PURE__ */ React.createElement(
      SearchForm,
      {
        onSearch: (newQuery) => setPagination({ ...pagination, page: INITIAL_PAGE, query: newQuery }),
        label: "Filter",
        queryWidth: 300,
        wrapperClass: "has-bm",
        placeholder: "Enter query to filter",
        queryHelpComponent: queryHelper
      }
    ),
    /* @__PURE__ */ React.createElement(ResultsWrapperComponent, { isEmptyResult: !itemList }, itemList != null ? itemList : emptyResult)
  );
};
export default PaginatedItemOverview;
